import { OmneoListItemMeta } from '../types'

export class WishlistListItemDraft {
  constructor({ sku, meta }: { sku: string; meta: OmneoListItemMeta }) {
    this.product_variant_sku = sku
    this.meta = meta
  }

  product_variant_sku: string
  meta: OmneoListItemMeta
}